import type { LoaderFunctionArgs } from 'react-router-dom';
import { redirect } from 'react-router-dom';

import { fetchCareSuggestPatient } from '@/entities/care-patients';
import { logger } from '@/shared';

export type AutofocusPatientLoaderData = { status: 'noPatients' };

export async function autofocusPatientLoader({
  request,
}: LoaderFunctionArgs): Promise<AutofocusPatientLoaderData> {
  try {
    const response = await fetchCareSuggestPatient(request.signal);
    const userId = response.patient?.user_id ?? null;
    if (typeof userId === 'string' && userId.trim() !== '') {
      throw redirect(`/patient/${userId}`);
    }

    logger.warn('No patients available for clinician; staying on autofocus route');
    return { status: 'noPatients' };
  } catch (error) {
    if (error instanceof Response) {
      throw error;
    }
    logger.warn('Patient autofocus failed; staying on autofocus route', { error });
    return { status: 'noPatients' };
  }
}
